import React, { useEffect } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Page from 'Components/Page';
import * as actions from 'Store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import ItemDetails from 'Components/ItemDetails';
import Divider from 'Components/Divider';
import IconButton from '@material-ui/core/IconButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import Button from '@material-ui/core/Button';
import history from '../history';

const pageStyles = theme => ({
  pageWrapper: {
    paddingLeft: '4%',
    paddingRight: '4%',
  },
  itemContainer: {
    marginTop: '50px',
  },
  registerTagButton: {
    marginTop: '50px',
  },
});

function Dashboard({
  user,
  classes,
  userItems,
  productData,
  getUserItems,
  getProductData,
  setActiveModal,
  saveItemDraftInfo,
}) {
  const productsString = JSON.stringify(productData);

  useEffect(() => {
    getProductData();
  }, [productsString, getProductData]);

  useEffect(() => {
    getUserItems();
  }, [getUserItems, user]);

  async function editItem(item) {
    await saveItemDraftInfo(item);
    history.push('/edit-item');
  }

  function renderDeleteItemButton(itemId) {
    return (
      <IconButton className={classes.button} aria-label="delete" size="small">
        <DeleteForeverIcon
          fontSize="small"
          onClick={() => {
            setActiveModal(`delete-item-${itemId}`);
          }}
        />
      </IconButton>
    );
  }

  function renderEditItemButton(item) {
    return (
      <IconButton className={classes.button} aria-label="delete" size="small">
        <EditIcon onClick={() => editItem(item)} fontSize="small" />
      </IconButton>
    );
  }

  function renderItems(items) {
    return items.map((item, index) => {
      const matchingProducts = productData.filter(product => product.productId === item.typeId)[0];
      let productUrl = '';

      if (matchingProducts && matchingProducts.imageUrl) {
        productUrl = matchingProducts ? matchingProducts.imageUrl : '';
      }

      // When there is no image
      const image = (item.images && item.images[0]) || '';

      return (
        <div key={item.itemId} className={classes.itemContainer}>
          <ItemDetails
            name={item.name}
            productUrl={productUrl}
            itemId={item.itemId}
            message={item.message}
            phone={item.phone}
            imageUrl={image}
            secondaryHeaderContent={
              <>
                {renderEditItemButton(item)}
                {renderDeleteItemButton(item.itemId)}
              </>
            }
          />
          {index < items.length - 1 && <Divider />}
        </div>
      );
    });
  }

  const renderPageContent = () => {
    if (userItems.length === 0) {
      return (
        <>
          <Typography variant="body1">You have not created any tags. Click below to get started.</Typography>
          <Button
            type="button"
            variant="contained"
            color="primary"
            to="/add-item"
            className={classes.registerTagButton}
            component={Link}
          >
            Register Tag
          </Button>
        </>
      );
    }

    return (
      <>
        {/* <Typography variant="h5">Registered Tags:</Typography> */}
        {renderItems(userItems)}
      </>
    );
  };

  return (
    <Page wrapperStyles={classes.pageWrapper}>
      <Typography variant="h1" className={classes.pageHeader}>
        Owner Dashboard
      </Typography>
      {renderPageContent()}
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setActiveModal: actions.setActiveModal,
      saveItemDraftInfo: actions.saveItemDraftInfo,
      getProductData: actions.getProductData,
      getUserItems: actions.getUserItems,
      deleteItem: actions.deleteItem,
    },
    dispatch,
  );
}

function mapStateToProps({ userItems, user, activeModal, productData }) {
  // had to take this out because it was forwarding the page
  // even if logged in becuase the user wasn't loaded yet
  // if (!user) {
  //   history.replace('/');
  // }

  return {
    user,
    userItems,
    activeModal,
    productData,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(pageStyles)(Dashboard)));
